import { Button } from "~/components/ui/button";
import { Document } from "~/document";
import { observer } from "mobx-react";
import { useEffect } from "react";
import bookmarkStore from "~/stores/bookmarks";
import { Star } from "lucide-react";
import { cn } from "~/lib/utils";

const DocBookmarkButton = observer((props: { doc: Document; className?: string }) => {
  const { doc } = props;
  const bookmarked = bookmarkStore.isBookmarked(doc.id);
  const loaded = bookmarkStore.isLoadedFor(doc.id);
  const title = bookmarked ? "Remove bookmark" : "Add bookmark";

  useEffect(() => {
    bookmarkStore.loadFor(doc.id);
  }, [doc.id]);

  const toggle = async () => {
    await bookmarkStore.toggleBookmarkedStatus(doc, !bookmarked);
  };

  if (!loaded) return null;

  return (
    <Button
      variant={bookmarked ? "default" : "secondary"}
      size="sm"
      aria-label={title}
      title={title}
      onClick={toggle}
      className={props.className}
    >
      <Star className={cn("size-4", bookmarked && "fill-current")} />
      {bookmarked ? "Bookmarked" : "Add bookmark"}
    </Button>
  );
});

export default DocBookmarkButton;
